import type { GetInputPropsReturnType } from "@mantine/form";
import { PasswordInput, TextInput, UnstyledButton } from "@mantine/core";
import type { LoginTr } from "../../useLoginTranslations";
import styles from "../../LoginPage.module.css";

export interface EmailPasswordFieldsProps {
  emailInputProps: GetInputPropsReturnType;
  passwordInputProps: GetInputPropsReturnType;
  confirmPasswordInputProps: GetInputPropsReturnType;
  isSignUp: boolean;
  onForgotPasswordClick: () => void;
  tr: LoginTr;
}

export function EmailPasswordFields({
  emailInputProps,
  passwordInputProps,
  confirmPasswordInputProps,
  isSignUp,
  onForgotPasswordClick,
  tr,
}: EmailPasswordFieldsProps) {
  return (
    <>
      <TextInput
        className={styles.authInput}
        label={tr("login.form.emailLabel", "Email")}
        placeholder="you@company.com"
        {...emailInputProps}
        required
        withAsterisk
        autoComplete="email"
      />

      {isSignUp ? (
        <PasswordInput
          className={styles.authInput}
          label={tr("login.form.passwordLabel", "Password")}
          placeholder="••••••••"
          {...passwordInputProps}
          required
          withAsterisk
          autoComplete="new-password"
        />
      ) : (
        <PasswordInput
          className={`${styles.authInput} ${styles.passwordFieldWrapper}`}
          label={
            <span className={styles.passwordLabelRow}>
              <span>
                {tr("login.form.passwordLabel", "Password")}
                <span className={styles.requiredAsterisk} aria-hidden>
                  {" *"}
                </span>
              </span>
              <UnstyledButton
                type="button"
                className={styles.linkButton}
                onClick={onForgotPasswordClick}
                aria-label={tr("login.form.forgotPassword", "Forgot password?")}
              >
                {tr("login.form.forgotPassword", "Forgot password?")}
              </UnstyledButton>
            </span>
          }
          placeholder="••••••••"
          {...passwordInputProps}
          required
          withAsterisk={false}
          autoComplete="current-password"
        />
      )}

      {isSignUp && (
        <PasswordInput
          className={styles.authInput}
          label={tr("login.form.confirmPasswordLabel", "Confirm Password")}
          placeholder="••••••••"
          {...confirmPasswordInputProps}
          required
          withAsterisk
          autoComplete="new-password"
        />
      )}
    </>
  );
}
